function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Grid, Flex, useData, Icon, Collapsible, Layout, Divider } from 'unitx-ui';
import * as R from 'unitx/ramda';
import { DATA_TYPE, EVENT } from "../../../utils/constants";
import { TripleInput } from "./TripleInput";
import { NewTripleItem } from "./NewTripleItem";
const ICON_SIZE = 15;
export const MockTripleItemProps = {
  name: 'foaf:name',
  value: ['Holland', 'Netherlands'],
  type: DATA_TYPE.string,
  additional: [{
    name: '@lang',
    value: ['en'],
    type: DATA_TYPE.string
  }],
  onEvent: (type, extraData) => {
    console.log('onEvent', type, extraData);
  }
};
export const TripleItem = props => {
  const {
    name,
    type,
    additional = [],
    isAdditional = false,
    onEvent = R.identity,
    isGlobalLabel,
    isLocalLabel,
    isGlobalLabelFirst
  } = props;
  const value = R.ensureArray(props.value);
  const [state, update] = useData({
    extended: false,
    settingsOpened: true,
    newDataValue: ''
  });
  const isMulti = value.length > 1;
  const onExtend = React.useCallback(() => {
    update(draft => {
      draft.extended = !draft.extended;
    });
  }, [update]);
  return /*#__PURE__*/React.createElement(Grid, {
    col: true,
    style: {
      size: 12
    }
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid, {
    col: true,
    style: {
      size: 5.5
    }
  }, /*#__PURE__*/React.createElement(TripleInput, {
    placeholder: "Enter Type",
    value: name,
    onValueChange: value => onEvent(EVENT.CHANGE_DATA_NAME, {
      value
    }) // type={DATA_TYPE.string}

  })), /*#__PURE__*/React.createElement(Grid, {
    col: true,
    style: {
      size: 5.5
    }
  }, R.ensureArray(value).map((valueItem, valueIndex) => /*#__PURE__*/React.createElement(Grid, {
    style: {
      marginBottom: 5
    }
  }, /*#__PURE__*/React.createElement(TripleInput, {
    placeholder: "Enter Value",
    value: valueItem,
    onValueChange: value => onEvent(EVENT.CHANGE_DATA_VALUE, {
      value,
      valueIndex
    }) // type={type}

  }), /*#__PURE__*/React.createElement(Flex, {
    col: true,
    style: {
      width: ICON_SIZE
    }
  }, isMulti && /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.DELETE_DATA_VALUE, {
      valueIndex,
      valueItem
    })
  }), isMulti && !isAdditional && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-up",
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.DATA_VALUE_UP, {
      valueIndex,
      valueItem
    })
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-down",
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.DATA_VALUE_DOWN, {
      valueIndex,
      valueItem
    })
  }))))), state.extended && /*#__PURE__*/React.createElement(TripleInput, {
    textStyle: {
      borderBottomWidth: 1,
      marginBottom: 5,
      fontStyle: 'italic'
    },
    placeholder: "Enter Value",
    value: state.newDataValue,
    onValueChange: value => update(draft => {
      draft.newDataValue = value;
    }),
    onEnter: () => {
      onEvent(EVENT.ADD_DATA_VALUE, {
        value: state.newDataValue
      });
      update(draft => {
        draft.newDataValue = '';
      });
    }
  })), /*#__PURE__*/React.createElement(IconBox, {
    isAdditional: isAdditional,
    extended: state.extended,
    onExtend: onExtend,
    onEvent: onEvent,
    type: type,
    isLocalLabel: isLocalLabel,
    isGlobalLabel: isGlobalLabel,
    isGlobalLabelFirst: isGlobalLabelFirst
  })), /*#__PURE__*/React.createElement(AdditionalInfo, {
    extended: state.extended,
    additional: additional,
    onEvent: onEvent
  }));
};

const AdditionalInfo = props => {
  const {
    extended,
    additional = [],
    onEvent
  } = props;
  return /*#__PURE__*/React.createElement(Collapsible, {
    collapsed: !extended,
    style: {
      width: '95%',
      marginLeft: '5%'
    }
  }, /*#__PURE__*/React.createElement(Layout, {
    style: {
      width: '100%'
    },
    level: "2"
  }, /*#__PURE__*/React.createElement(Divider, null), additional.map((item, index) => /*#__PURE__*/React.createElement(TripleItem, _extends({}, item, {
    isAdditional: true,
    onEvent: (type, extraData) => {
      switch (type) {
        case EVENT.CHANGE_DATA_NAME:
          onEvent(EVENT.CHANGE_DATA_NAME_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
            index
          }));
          break;

        case EVENT.CHANGE_DATA_VALUE:
          {
            onEvent(EVENT.CHANGE_DATA_VALUE_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
              index
            }));
            break;
          }

        case EVENT.ADD_DATA:
          onEvent(EVENT.ADD_DATA_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
            index
          }));
          break;

        case EVENT.ADD_DATA_VALUE:
          {
            onEvent(EVENT.ADD_DATA_VALUE_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
              index
            }));
            break;
          }

        case EVENT.DELETE_DATA_VALUE:
          onEvent(EVENT.DELETE_DATA_VALUE_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
            index
          }));
          break;

        case EVENT.DELETE_DATA:
          onEvent(EVENT.DELETE_DATA_ADDITIONAL, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
            index
          }));
          break;

        default:
          onEvent(type, _objectSpread(_objectSpread({}, extraData !== null && extraData !== void 0 ? extraData : {}), {}, {
            index
          }));
          break;
      }
    }
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(NewTripleItem, {
    style: {
      marginBottom: 2
    },
    onAdd: data => onEvent(EVENT.ADD_DATA_ADDITIONAL, data)
  })));
};

const IconBox = props => {
  const {
    isAdditional,
    onExtend,
    extended,
    onEvent,
    isGlobalLabel,
    isLocalLabel,
    isGlobalLabelFirst
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isAdditional && /*#__PURE__*/React.createElement(Flex, {
    col: true,
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: isLocalLabel ? 'tag-remove' : 'tag',
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.MAKE_DATA_LABEL),
    onLongPress: () => onEvent(EVENT.MAKE_DATA_LABEL_FIRST)
  }), !isGlobalLabelFirst && /*#__PURE__*/React.createElement(Divider, {
    style: {
      backgroundColor: 'black',
      marginTop: 1,
      marginBottom: 1,
      width: ICON_SIZE - 2
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    name: isGlobalLabel ? 'tag-remove' : 'tag-multiple',
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.MAKE_GLOBAL_DATA_LABEL),
    onLongPress: () => onEvent(EVENT.MAKE_GLOBAL_DATA_LABEL_FIRST)
  }), isGlobalLabelFirst && /*#__PURE__*/React.createElement(Divider, {
    style: {
      backgroundColor: 'black',
      width: ICON_SIZE - 2
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    col: true
  }, !isAdditional && /*#__PURE__*/React.createElement(Icon, {
    name: extended ? 'chevron-up-box' : 'chevron-down-box',
    size: ICON_SIZE,
    onPress: onExtend
  }), extended && /*#__PURE__*/React.createElement(Icon, {
    name: "delete",
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.DELETE_DATA)
  }), isAdditional && /*#__PURE__*/React.createElement(Icon, {
    name: "plus-box-outline",
    size: ICON_SIZE,
    onPress: () => onEvent(EVENT.ADD_DATA_VALUE)
  })));
};